exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__MilestoneTickIcon___2Mx9l{height:.7rem;width:.7rem}.styles__MilestoneCrossIcon___3C1wy{height:.65rem;width:.65rem}", ""]);

// Exports
exports.locals = {
	"MilestoneTickIcon": "styles__MilestoneTickIcon___2Mx9l",
	"MilestoneCrossIcon": "styles__MilestoneCrossIcon___3C1wy"
};